var map = {
  "./assets/favicons-prodsgp1/android-chrome-192x192.png": "19226",
  "./assets/favicons-prodsgp1/android-chrome-512x512.png": "56058",
  "./assets/favicons-prodsgp1/apple-touch-icon.png": "50493",
  "./assets/favicons-prodsgp1/browserconfig.xml": "4921",
  "./assets/favicons-prodsgp1/favicon-16x16.png": "39508",
  "./assets/favicons-prodsgp1/favicon-32x32.png": "75024",
  "./assets/favicons-prodsgp1/favicon-alert-16x16.png": "72053",
  "./assets/favicons-prodsgp1/favicon-alert-32x32.png": "56805",
  "./assets/favicons-prodsgp1/favicon-alert.ico": "75206",
  "./assets/favicons-prodsgp1/favicon.ico": "49551",
  "./assets/favicons-prodsgp1/mstile-150x150.png": "70270",
  "./assets/favicons-prodsgp1/site.webmanifest": "85100",
  "./assets/favicons-prodsgp1/upc-favicon.ico": "46794"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 93445;
